var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94379 3.21967C10.2699 2.92678 10.7985 2.92678 11.1246 3.21967L15.856 7.46968C16.1821 7.76257 16.1821 8.23745 15.856 8.53034L11.1246 12.7803C10.7985 13.0732 10.2699 13.0732 9.94379 12.7803C9.61772 12.4874 9.61772 12.0126 9.94379 11.7197L13.2498 8.75001H0.834962C0.373829 8.75001 0 8.41422 0 8.00001C0 7.5858 0.373829 7.25001 0.834962 7.25001H13.2498L9.94379 4.28033C9.61772 3.98744 9.61772 3.51256 9.94379 3.21967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic-next.63d85ed255945e97183072a4b8186ada.svg";
export { ForwardRef as ReactComponent };